if (!customElements.get('hero-slider')) {
  class HeroSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.options = {
        slidesPerView: 1,
        spaceBetween: 0,
        a11y: {
          prevSlideMessage: 'Previous slide',
          nextSlideMessage: 'Next slide',
        },
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          clickable: true,
        },
        navigation: {
          nextEl: this.querySelector('.swiper-arrow--next'),
          prevEl: this.querySelector('.swiper-arrow--prev'),
        },
      };

      if (this.hasAttribute('js-loop')) {
        this.options['loop'] = true;
      }

      if (this.hasAttribute('js-autoplay')) {
        this.options['autoplay'] = {
          delay: Number(this.getAttribute('js-autoplay')),
        };
      }

      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.options,
      );
    }
  }

  customElements.define('hero-slider', HeroSlider);
}
